import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 7.75736V16.2426M12 7.75736L8.81802 10.9393M12 7.75736L15.182 10.9393M21.0001 12C21.0001 16.971 16.971 21.0001 12 21.0001C7.02904 21.0001 2.99995 16.971 2.99995 12C2.99995 7.02904 7.02904 2.99994 12 2.99994C16.971 2.99994 21.0001 7.02904 21.0001 12Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgArrowCircleUp);
export default ForwardRef;
